import { type FunctionComponent, type PropsWithChildren, createContext } from 'react'
import dict from './dictionary'
import { useCallback, useContext, useState } from 'react'
import languageDetector from '../../utils/languageDetector'

const Localization = createContext<{
  text: (key: keyof (typeof dict)['en' | 'de'], defaultText?: string) => string
  currentLang: keyof typeof dict
}>(null!)

const LocalizationProvider: FunctionComponent<PropsWithChildren<{ locale: keyof typeof dict }>> = ({
  children,
  locale,
}) => {
  const [currentLang] = useState<keyof typeof dict>(() => locale)
  const [lng] = useState(() => dict[locale as keyof typeof dict])

  const text = useCallback(
    (key: keyof typeof lng, defaultText?: string) => (lng ? lng[key] : dict.en[key] || defaultText || ''),
    [lng],
  )

  return (
    <Localization.Provider
      value={{
        text,
        currentLang,
      }}
    >
      {children}
    </Localization.Provider>
  )
}

export const useTranslation = () => useContext(Localization)
useTranslation.text = (key: keyof (typeof dict)['en' | 'de'], defaultText?: string): string =>
  dict[languageDetector()][key] || defaultText || key

export default LocalizationProvider
